<!--
 * @LastEditors: chg
 * @desc: 因子的数据详情（多场景使用）
-->
<template>
  <div>
    <div :id="this.id" :style="{height: '300px', width: '100%'}" v-loading="loading"></div>
  </div>
</template>
<script>
export default {
  props: ['id', 'activeName', 'theLabel', 'theData', 'num', 'template_params', 'y_axis_name', 'zoomData'],
  data () {
    return {
      loading: false,
      myChart: null,
      option: {},
      markAreaData: []
    }
  },
  mounted () {
    var _this = this
    window.wordClick = function (data) {
      _this.$emit('drawDate', data)
    }
    this.clearData()
  },
  methods: {
    // 判断当前值是否应该阴影显示
    check_value (val, params) {
      if (params.direction === 1) {
        if (val >= params.value) {
          return true
        }
        return false
      }
      if (params.direction === -1) {
        if (val <= params.value) {
          return true
        }
        return false
      }
      if (params.direction === 0) {
        if (val <= params.value2 & val >= params.value1) {
          return true
        }
        return false
      }
      return false
    },
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      if (this.myChart === null) {
        this.myChart = this.$echarts.init(document.getElementById(this.id))
      }
      // 绘制图表
      this.option = {
        tooltip: {
          trigger: 'axis',
          triggerOn: 'click',
          enterable: true,
          formatter: (param) => {
            let data = param[0]
            let text = '- '
            if (data.value !== null && data.value !== undefined) {
              text = data.value
            }
            return '<span style="user-select: text;">' + data.name + '</span><br/>' + '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:' + data.color + '"></span><span style="user-select: text;margin-right:5px;">' + text + '</span><button style="line-height: 24px; background: #fff; color: #444;" onclick="wordClick(\'' + data.name + '\')">详情</button>'
          }
        },
        toolbox: {
          show: true
        },
        grid: {
          show: true,
          top: '10%'
        },
        xAxis: {
          type: 'category',
          data: this.theLabel,
          // 网格样式
          splitLine: {
            show: true
          },
          boundaryGap: false
        },
        yAxis: [{
          name: this.y_axis_name,
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          },
          min: 'dataMin',
          max: 'dataMax'
        }],
        series: [{
          data: this.theData,
          type: 'line',
          color: '#c64743',
          // symbolSize: 10,
          connectNulls: true,
          lineStyle: {
            width: 2 // 设置线条粗细
          },
          markArea: {
            itemStyle: {
              color: '#AAAAAA',
              opacity: 0.5
            }
          },
          markLine: {
            symbol: ['none', 'none'], // ['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
            label: {
              color: '#FFF',
              position: 'end' // 将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
            },
            silent: true, // 鼠标悬停事件 true没有，false有
            lineStyle: { // 警戒线的样式 ，虚实 颜色
              type: 'solid', // 样式  ‘solid’和'dotted'
              color: '#AAAAAA',
              width: 0 // 宽度
            },
            data: [{
              yAxis: 0 // 警戒线的标注值，可以有多个yAxis,多条警示线 或者采用 {type : 'average', name: '平均值'}，type值有 max min average，分为最大，最小，平均值
            }]
          }
        }],
        dataZoom: [
          {
            type: 'inside',
            startValue: this.theLabel[0],
            endValue: this.theLabel[this.theLabel.length - 1]
          },
          {
            show: true,
            type: 'slider',
            fillerColor: 'rgba(167, 183, 204, 0.4)',
            top: '90%'
          }
        ]
      }
      var _this = this
      this.loading = false
      this.myChart.setOption(this.option)
      window.addEventListener('resize', function () {
        _this.myChart.resize()
        if (_this.myChart) {
          _this.myChart.resize()
        }
      })
      this.myChart.on('dataZoom', function (params) {
        let startValue = _this.myChart.getModel().option.dataZoom[0].startValue
        let endValue = _this.myChart.getModel().option.dataZoom[0].endValue
        if (_this.id === 'dialogItem' && (startValue !== 0 || endValue !== _this.theLabel.length - 1)) {
          _this.$emit('dataZoom', startValue, endValue)
        }
      })
    },
    clearData () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.myChart = this.$echarts.init(document.getElementById(this.id))
      this.myChart.clear()
    }
  },
  watch: {
    activeName (newVal, oldVal) {
      this.clearData()
      // var _this = this
      this.activeName = newVal
      if (this.activeName === 'first') {
        this.loading = true
        this.drawLine()
      }
    },
    // 监听父组件传入的数据，更新到本地
    theLabel (newVal, oldVal) {
      if (!newVal || newVal.length < 1) {
        return
      }
      this.theLabel = newVal
      this.drawLine()
    },
    theData (newVal, oldVal) {
      if (!newVal || newVal.length < 1) {
        return
      }
      let max = Math.max.apply(null, newVal)
      let min = Math.min.apply(null, newVal)
      for (let i = 0; i < newVal.length; i++) {
        if (newVal[i] !== undefined && newVal[i] !== null) {
          if (max > 10 || min < -10) {
            newVal[i] = Math.round(1e2 * newVal[i]) / 1e2
          } else {
            newVal[i] = Math.round(1e6 * newVal[i]) / 1e6
          }
        }
      }
      this.theData = newVal
      this.option['series'][0].data = this.theData
      this.myChart.setOption(this.option)
      this.drawLine()
      if (this.zoomData !== undefined && this.zoomData.length > 0) {
        this.option['dataZoom'][0].startValue = this.zoomData[0]
        this.option['dataZoom'][0].endValue = this.zoomData[1]
        this.myChart.setOption(this.option)
      }
    },
    // 监听父组件传入的数据，更新到本地
    id (newVal, oldVal) {
      this.id = newVal
      this.drawLine()
    },
    y_axis_name (newVal, oldVal) {
      this.y_axis_name = newVal
      // this.option['yAxis'][0].name = this.y_axis_name
    },
    zoomData (newVal, oldVal) {
      if (this.id === 'dialogItem') {
        this.zoomData = newVal
        // this.drawLine()
        // if (this.zoomData !== undefined && this.zoomData.length > 0) {
        //   this.option['dataZoom'][0].startValue = this.zoomData[0]
        //   this.option['dataZoom'][0].endValue = this.zoomData[1]
        //   this.myChart.setOption(this.option)
        // }
      }
    },

    $route  () {
      console.log('路由改变了')
    }
  },
  activated () {
    console.log('激活了')
    if (this.myChart) {
      this.myChart.resize()
    }
    // this.clearData()
  }
}
</script>
<style scoped>
  .el-collapse-item {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  .el-collapse-item__header {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  .el-collapse-item__wrap {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  h4 {
    margin-bottom:0px;
  }
  .bannerTextRed{
    padding: 0 4px;
    line-height: 18px;
    height: 18px;
    border-radius: 4px;
    font-weight: 400;
    background-color:indianred;
    color:white;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/timeSeries/lineDetails.vue